// Iconos SVG inline compartidos entre panel-cliente y panel-super-admin.
//
// Cada función devuelve un string SVG con un path de 16x16 (viewport 0 0 16 16)
// escalable vía CSS. Usan `currentColor` para que hereden el color del contexto.
// No requieren ninguna dependencia externa.
//
// Uso:
//   import { iconoDashboard } from '@plataforma/ui/src/iconos.js';
//   elemento.innerHTML = `<span class="pf-icono">${iconoDashboard()}</span>`;

const SVG_ATTRS =
  'viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"';

const ENVUELTO = (inner) => `<svg ${SVG_ATTRS}>${inner}</svg>`;

/* ---------------------------------------------------------------------- */
/* Navegación / módulos                                                     */
/* ---------------------------------------------------------------------- */

export function iconoDashboard() {
  return ENVUELTO(`
    <path d="M1.5 2.5A1 1 0 0 1 2.5 1.5h4a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-5Z" stroke="currentColor" stroke-width="1.2"/>
    <path d="M9.5 2.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-3Z" stroke="currentColor" stroke-width="1.2"/>
    <path d="M1.5 10.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4Z" stroke="currentColor" stroke-width="1.2"/>
    <path d="M9.5 9.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-5Z" stroke="currentColor" stroke-width="1.2"/>
  `);
}

export function iconoProductos() {
  return ENVUELTO(`
    <path d="M8 1.5 1.5 5v6L8 14.5 14.5 11V5L8 1.5Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
    <path d="M1.5 5 8 8.5 14.5 5" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
    <path d="M8 8.5V14.5" stroke="currentColor" stroke-width="1.2"/>
  `);
}

export function iconoCategorias() {
  return ENVUELTO(`
    <path d="M1.5 3.5a1 1 0 0 1 1-1h4l2 2h5a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1v-9Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
  `);
}

export function iconoPagina() {
  return ENVUELTO(`
    <path d="M2.5 1.5h7L13.5 5.5v8a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
    <path d="M5.5 8.5h5M5.5 11.5h3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
    <path d="M9.5 1.5v4h4" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
  `);
}

export function iconoApariencia() {
  return ENVUELTO(`
    <path d="M8 1.5a6.5 6.5 0 1 0 0 13c.83 0 1.5-.67 1.5-1.5 0-.4-.16-.76-.42-1.02-.26-.26-.42-.62-.42-1.02 0-.83.67-1.5 1.5-1.5h1.67A3.17 3.17 0 0 0 15 6.33 6.5 6.5 0 0 0 8 1.5Z" stroke="currentColor" stroke-width="1.2"/>
    <circle cx="5" cy="6" r="1" fill="currentColor"/>
    <circle cy="8.5" cx="7" r="0.8" fill="currentColor"/>
    <circle cx="4.5" cy="10.5" r="0.8" fill="currentColor"/>
  `);
}

export function iconoEmpresa() {
  return ENVUELTO(`
    <path d="M1.5 14.5V4.35a1 1 0 0 1 .6-.92l6-2.5a1 1 0 0 1 .8 0l6 2.5a1 1 0 0 1 .6.92v10.15" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
    <path d="M5 14.5V9h6v5.5" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
    <path d="M5 6h1M9 6h1M5 8.5h1M9 8.5h1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  `);
}

export function iconoVariantes() {
  return ENVUELTO(`
    <path d="M8 1.5 1.5 5 8 8.5 14.5 5 8 1.5Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
    <path d="M1.5 8 8 11.5 14.5 8" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
    <path d="M1.5 11 8 14.5 14.5 11" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
  `);
}

export function iconoCupones() {
  return ENVUELTO(`
    <path d="M1.5 4.5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.5a2 2 0 0 0 0 4v.5a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1V9a2 2 0 0 0 0-4v-.5Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
    <path d="M6 6v4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  `);
}

export function iconoEmpresas() {
  return ENVUELTO(`
    <path d="M2.5 14.5V5.35a1 1 0 0 1 .55-.9l5-2.5a1 1 0 0 1 .9 0l5 2.5a1 1 0 0 1 .55.9v9.15" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
    <path d="M5.5 14.5V9.5h5v5" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
    <path d="M5.5 5h1M9.5 5h1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  `);
}

export function iconoUsuarios() {
  return ENVUELTO(`
    <circle cx="5.5" cy="4.5" r="2.5" stroke="currentColor" stroke-width="1.2"/>
    <path d="M1 14.5a4.5 4.5 0 0 1 9 0" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
    <circle cx="10.5" cy="5" r="2" stroke="currentColor" stroke-width="1.2"/>
    <path d="M14 14.5a3.5 3.5 0 0 0-5.5-2.8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  `);
}

export function iconoDominios() {
  return ENVUELTO(`
    <circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="1.2"/>
    <path d="M1.5 8h13M8 1.5c-2 2-2 11 0 13M8 1.5c2 2 2 11 0 13" stroke="currentColor" stroke-width="1.2"/>
  `);
}

export function iconoContrataciones() {
  return ENVUELTO(`
    <rect x="1.5" y="2.5" width="13" height="12" rx="1" stroke="currentColor" stroke-width="1.2"/>
    <path d="M1.5 6h13M5 1v3M11 1v3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
    <path d="M5.5 9.5h5M5.5 12h3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  `);
}

export function iconoPublicaciones() {
  return ENVUELTO(`
    <path d="M8 1.5v13M4.5 5l3.5-3.5L11.5 5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3 9v4.5a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  `);
}

/* ---------------------------------------------------------------------- */
/* Acciones / UI                                                            */
/* ---------------------------------------------------------------------- */

export function iconoCandado() {
  return ENVUELTO(`
    <rect x="3" y="7" width="10" height="7" rx="1" stroke="currentColor" stroke-width="1.2"/>
    <path d="M5 7V5a3 3 0 0 1 6 0v2" stroke="currentColor" stroke-width="1.2"/>
    <circle cx="8" cy="11" r="1" fill="currentColor"/>
  `);
}

export function iconoUsuario() {
  return ENVUELTO(`
    <circle cx="8" cy="5" r="3" stroke="currentColor" stroke-width="1.2"/>
    <path d="M2.5 14.5a5.5 5.5 0 0 1 11 0" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  `);
}

export function iconoCerrarSesion() {
  return ENVUELTO(`
    <path d="M6 2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
    <path d="M10.5 5.5 14 9l-3.5 3.5M6 9h8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  `);
}

export function iconoCerrar() {
  return ENVUELTO(`
    <path d="M3.5 3.5l9 9M12.5 3.5l-9 9" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
  `);
}

export function iconoAnadir() {
  return ENVUELTO(`
    <path d="M8 3.5v9M3.5 8h9" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
  `);
}

export function iconoEditar() {
  return ENVUELTO(`
    <path d="M10.5 2.5l2 2-8 8H2.5v-2l8-8Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
    <path d="M7.5 4.5l2 2" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  `);
}

export function iconoSubir() {
  return ENVUELTO(`
    <path d="M3 10v2.5A1.5 1.5 0 0 0 4.5 14h7A1.5 1.5 0 0 0 13 12.5V10" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 10.5V2.5M5.5 5 8 2.5 10.5 5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  `);
}

export function iconoImagen() {
  return ENVUELTO(`
    <rect x="1.5" y="2.5" width="13" height="11" rx="1.5" stroke="currentColor" stroke-width="1.2"/>
    <circle cx="5.5" cy="6" r="1.3" fill="currentColor"/>
    <path d="M2 11.5l3.5-3 2.5 2.5 3.5-3.5 2.5 2.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  `);
}

export function iconoEliminar() {
  return ENVUELTO(`
    <path d="M3 4h10M6.5 4V2.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1V4M4.5 4l.5 9a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1l.5-9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7 7v5M9 7v5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  `);
}

export function iconoPublicar() {
  return ENVUELTO(`
    <path d="M8 1.5v13M4.5 5l3.5-3.5L11.5 5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3 9v4.5a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  `);
}

export function iconoLlave() {
  return ENVUELTO(`
    <circle cx="5" cy="11" r="3" stroke="currentColor" stroke-width="1.2"/>
    <path d="M8 8l5-5M10.5 3l2.5 2.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  `);
}

/* ---------------------------------------------------------------------- */
/* Compartir tienda (Dashboard)                                            */
/* ---------------------------------------------------------------------- */

export function iconoEnlace() {
  return ENVUELTO(`
    <path d="M6.5 9.5a3.5 3.5 0 0 0 5 0l2-2a3.5 3.5 0 1 0-5-5l-1 1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.5 6.5a3.5 3.5 0 0 0-5 0l-2 2a3.5 3.5 0 1 0 5 5l1-1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  `);
}

export function iconoCopiar() {
  return ENVUELTO(`
    <rect x="5.5" y="5.5" width="8" height="8" rx="1.5" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
    <path d="M3.5 10.5v-6A1.5 1.5 0 0 1 5 3h6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  `);
}

export function iconoAbrir() {
  return ENVUELTO(`
    <path d="M9.5 2.5H13v3.5M13 2.5 7.5 8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11 8.5V12a1.5 1.5 0 0 1-1.5 1.5h-6A1.5 1.5 0 0 1 2 12V6a1.5 1.5 0 0 1 1.5-1.5H7" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  `);
}

export function iconoCompartir() {
  return ENVUELTO(`
    <circle cx="4" cy="8" r="2" stroke="currentColor" stroke-width="1.2"/>
    <circle cx="12" cy="3.5" r="2" stroke="currentColor" stroke-width="1.2"/>
    <circle cx="12" cy="12.5" r="2" stroke="currentColor" stroke-width="1.2"/>
    <path d="M5.8 7 10.2 4.5M5.8 9 10.2 11.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  `);
}

export function iconoCodigoQr() {
  return ENVUELTO(`
    <rect x="2" y="2" width="5" height="5" rx="1" stroke="currentColor" stroke-width="1.2"/>
    <rect x="9" y="2" width="5" height="5" rx="1" stroke="currentColor" stroke-width="1.2"/>
    <rect x="2" y="9" width="5" height="5" rx="1" stroke="currentColor" stroke-width="1.2"/>
    <path d="M10.5 10.5h2v2M14 9.5v-.5a2 2 0 0 0-2-2h-.5M10.5 14h2.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  `);
}

export function iconoDescargar() {
  return ENVUELTO(`
    <path d="M8 2.5v7M5 6.5l3 3 3-3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3 10.5V12a1.5 1.5 0 0 0 1.5 1.5h7A1.5 1.5 0 0 0 13 12v-1.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
  `);
}

export function iconoCheck() {
  return ENVUELTO(`
    <path d="M3 8.5 6.5 12 13 4.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
  `);
}

export function iconoWhatsApp() {
  return ENVUELTO(`
    <path d="M6.2 2.9a5.3 5.3 0 0 1 9.3 3.6c0 3.1-2.5 5.6-5.6 5.6-.9 0-1.8-.2-2.6-.6l-2.8.9.8-2.7a5.3 5.3 0 0 1-.6-2.6c0-2.9 2.4-5.3 5.3-5.3Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>
    <path d="M5.6 5.6h1l.8 1.6-1 1A3.3 3.3 0 0 0 8 10.4a3.3 3.3 0 0 0 1.7-1.1l1 .8.8 2z" stroke="currentColor" stroke-width="1" stroke-linejoin="round"/>
  `);
}

export function iconoFacebook() {
  return ENVUELTO(`
    <path d="M9.5 8V6.3c0-.8.6-1 .9-1H12V3L9.8 3C7.8 3 7 4.5 7 6.2V8H5.3v2.3H7V13h2.5v-2.7h1.9L12 8.3H9.5Z" stroke="currentColor" stroke-width="0.9" stroke-linejoin="round"/>
  `);
}

export function iconoTelegram() {
  return ENVUELTO(`
    <path d="M13.5 2.5 2 7.2l4.2 1.6L13.5 2.5ZM6.3 8.8l.6 4.2 1.4-2 2.4 1.4 2.8-8.2-7.2 4.6Z" stroke="currentColor" stroke-width="1" stroke-linejoin="round"/>
  `);
}
